import SmartToyOutlined from '@mui/icons-material/SmartToyOutlined';
import { useTheme } from '@mui/material';
import { Box } from '@mui/system';
import { TicketSource } from '@treadinc/horizon-api-spec';

interface TicketSourceBadgeProps {
  ticketSource: TicketSource;
}

export default function TicketSourceBadge({ ticketSource }: TicketSourceBadgeProps) {
  const theme = useTheme();

  if (ticketSource === TicketSource.AGENT) {
    return (
      <Box
        sx={{
          position: 'absolute',
          bottom: theme.spacing(0.25),
          right: theme.spacing(0.25),
          backgroundColor: theme.brandV2.colors.treadGray8,
          borderRadius: theme.spacing(0.5),
          p: '1px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: `solid 1px ${theme.brandV2.colors.treadBlue}`,
        }}
      >
        <SmartToyOutlined
          sx={{
            fontSize: '14px',
            color: theme.brandV2.colors.treadBlue,
            opacity: 1,
          }}
        />
      </Box>
    );
  }
}
